import React, { useState } from "react";
import "../Styles/Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../Assets/logo.png";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false); // Closes menu after click

  return (
    <nav className="navbar">
      <div className="nav-left">
        <NavLink to="/" className="a-logo" onClick={closeMenu}>
          <img src={logo} alt="Logo" className="logo" />
        </NavLink>
      </div>

      <div className="nav-toggle" onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      <div className={`nav-right ${isOpen ? "open" : ""}`}>
        <ul className="nav-links">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>
         <li>
            <NavLink
              to="/coursePage"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Our Courses
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              About us
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Gallery
            </NavLink>
          </li>
          <span className="contact-us">
            <a href="/#contact" onClick={closeMenu}>
              Contact us
            </a>
          </span>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
